<template>
  <MCard :shadow="shadow" type="inner">
    <template v-slot:header>
      <MTooltip>
        <template v-slot:trigger>
          {{ title }}
        </template>
        {{ title }}
      </MTooltip>
    </template>
    <slot name="box-count">
      <b>{{ count }}</b>
    </slot>
  </MCard>
</template>

<script>
export default {
  name: 'BoxNode',
  props: {
    title: { type: String, required: true },
    // eslint-disable-next-line
    shadow: { type: Boolean, default: true },
    count: { type: [Number, String], default: 0 },
  },
}
</script>
